import { CarouselRail } from '~/components-v2/carousel-rail/carousel-rail'
import { VideoFigure } from '~/components-v2/figure/video-figure'
import { type DocsDemosState, DEMOS_PAGE_URL } from '~/services/docs-demos'

/** The week's engineering demos on the site's carousel rail with its own geometry, three up, with this page's
 *  subhead. The site's EngineeringDemo component is the same shape two up with its own subhead; this stays
 *  route-local until a subheading prop lands there. */
export const Demos = ({ docsDemos }: { docsDemos?: DocsDemosState }) => {
  if (!docsDemos) return null
  const demos = docsDemos.demos.demos
    .filter((demo) => demo.videoUrl)
    .slice(0, 6)
  if (demos.length === 0) return null
  // the rest of the week's demos beyond the ones in the carousel
  const remaining = Math.max(docsDemos.demos.demos.length - demos.length, 0)

  return (
    <section
      className="page-section page-section--lg engineering-demo developers-demos"
      id="demos"
    >
      <div className="page-section__inner engineering-demo__inner">
        <CarouselRail
          className="engineering-demo__rail developers-demos__rail"
          desktopEndSpacerSlides={1}
          desktopVisibleSlides={3}
          header={
            <hgroup className="engineering-demo__header">
              <h2 className="heading-xl text-brand-dark">
                Peek at what we’re building
              </h2>
              <p className="body-l text-primary">
                Every week, our engineers share what they’re shipping. Watch the
                latest demo videos.
              </p>
            </hgroup>
          }
          viewAll={{
            external: true,
            href: DEMOS_PAGE_URL,
            label: `See ${remaining} More Demos from Last Week`,
          }}
          viewportControls
        >
          {demos.map((demo, index) => {
            const inner = demo.description.content?.[0]?.content?.[0]
            const summary = inner && 'value' in inner ? inner.value : null
            return (
              <article className="demo-card" key={`demo-${index}`}>
                {demo.videoUrl && (
                  <VideoFigure src={demo.videoUrl} title={demo.title} />
                )}
                <div className="demo-card__content">
                  <h3 className="demo-card__title heading-s">{demo.title}</h3>
                  <p className="demo-card__presenters body-s">
                    {demo.presenters
                      .map((presenter) => presenter.name)
                      .join(', ')}
                  </p>
                  {summary && (
                    <p className="demo-card__summary body-m">{summary}</p>
                  )}
                </div>
              </article>
            )
          })}
        </CarouselRail>
      </div>
    </section>
  )
}
